import React from "react";
import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import { useI18n } from "@/context/I18nContext";

export default function Footer() {
  const { t } = useI18n();
  return (
    <footer className="relative border-t border-white/10 bg-[#050505] overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-20 pb-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 mb-16">
          <div className="col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <Logo size={28} />
              <span className="font-display font-black tracking-tight text-lg">ViralCrew</span>
            </div>
            <p className="text-zinc-400 max-w-md text-sm">{t.footer.tagline}</p>
          </div>
          <div>
            <h4 className="text-xs font-mono uppercase tracking-wider text-zinc-500 mb-4">{t.footer.product}</h4>
            <ul className="space-y-2 text-sm text-zinc-300">
              <li><a href="/#features" className="hover:text-white">Features</a></li>
              <li><a href="/#pricing" className="hover:text-white">Pricing</a></li>
              <li><Link to="/login" className="hover:text-white">Login</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-xs font-mono uppercase tracking-wider text-zinc-500 mb-4">{t.footer.legal}</h4>
            <ul className="space-y-2 text-sm text-zinc-300">
              <li><Link to="/impressum" className="hover:text-white">Impressum</Link></li>
              <li><Link to="/datenschutz" className="hover:text-white">Datenschutz</Link></li>
              <li><Link to="/agb" className="hover:text-white">AGB</Link></li>
            </ul>
          </div>
        </div>

        <div className="relative">
          <h2 className="font-display font-black tracking-tighter text-[18vw] md:text-[14vw] leading-none select-none bg-gradient-to-b from-white/[0.04] to-transparent bg-clip-text text-transparent">
            VIRALCREW
          </h2>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between pt-8 border-t border-white/10 mt-4 text-xs text-zinc-500">
          <p>{t.footer.copyright}</p>
          <p className="font-mono">{t.footer.madeBy} <span aria-label="love">❤️</span></p>
        </div>
      </div>
    </footer>
  );
}
